import * as React from 'react';
import clsx from 'clsx';
import { useTranslator } from '@gandi/translate';
import { IconButton } from '@gandi/ui';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "RemoveButton-root_1ahqn",
  "small": "RemoveButton-small_2R1Yd"
};
export function RemoveButton({
  className,
  handleRemoveAction,
  small = false
}) {
  const {
    __
  } = useTranslator();
  const label = __('Remove product');
  const [deleting, setDeleting] = React.useState(false);
  return /*#__PURE__*/_jsx(IconButton, {
    icon: "trash",
    className: clsx(styles.root, small && styles.small, className),
    loading: deleting,
    small: true,
    title: label,
    onClick: e => {
      if (!deleting) {
        setDeleting(true);
        handleRemoveAction(e);
      }
    },
    children: label
  });
}